import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth, loginWithGoogle } from "../lib/AuthContext";
import { api, formatPrice } from "../lib/api";

export default function Account() {
  const { user, logout } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (user) api.get("/orders").then(r => setOrders(r.data)).catch(() => {});
  }, [user]);

  if (!user) return (
    <main className="pt-40 pb-32 text-center" data-testid="account-page">
      <h1 className="h-display text-5xl text-[#F8F4E6] mb-6">Contul Meu</h1>
      <p className="text-[#A39E8A] mb-8">Conectează-te pentru a vedea comenzile și profilul.</p>
      <button onClick={loginWithGoogle} className="btn-gold" data-testid="account-login">Conectare cu Google</button>
    </main>
  );

  return (
    <main className="pt-32 pb-20 min-h-screen" data-testid="account-page">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <header className="mb-16 flex items-center justify-between flex-wrap gap-6">
          <div className="flex items-center gap-6">
            {user.picture && <img src={user.picture} alt="" className="w-20 h-20 rounded-full border border-[#D4AF37]/40" />}
            <div>
              <p className="label-luxe text-[#D4AF37] mb-2">Bun venit</p>
              <h1 className="h-display text-4xl sm:text-5xl text-[#F8F4E6]">{user.name}</h1>
              <p className="text-sm text-[#A39E8A] mt-2">{user.email}</p>
            </div>
          </div>
          <div className="flex gap-3">
            {user.is_admin && <Link to="/admin" className="btn-ghost" data-testid="goto-admin">Dashboard Admin</Link>}
            <button onClick={logout} className="btn-ghost" data-testid="account-logout">Deconectare</button>
          </div>
        </header>

        <section>
          <h2 className="h-display text-3xl text-[#F8F4E6] mb-8">Comenzile Mele</h2>
          {orders.length === 0 ? (
            <div className="text-center py-16 border border-[#D4AF37]/15">
              <p className="text-[#A39E8A] mb-6">Nicio comandă încă.</p>
              <Link to="/shop" className="btn-gold">Descoperă Colecția</Link>
            </div>
          ) : (
            <ul className="space-y-4" data-testid="orders-list">
              {orders.map(o => (
                <li key={o.id} className="border border-[#D4AF37]/15 p-6 flex justify-between items-start flex-wrap gap-4" data-testid={`order-${o.id}`}>
                  <div className="flex-1 min-w-0">
                    <p className="label-luxe text-[#D4AF37]">Comandă #{o.id}</p>
                    <p className="font-serif text-xl text-[#F8F4E6] mt-2">{o.items_summary}</p>
                    <p className="text-xs text-[#A39E8A] mt-1">{new Date(o.created_at).toLocaleDateString("ro-RO")}</p>
                    {o.awb && (
                      <div className="mt-3 inline-flex flex-wrap items-center gap-3 text-xs">
                        <span className="label-luxe text-[#A39E8A]">AWB:</span>
                        <span className="text-[#D4AF37] font-mono">{o.awb}</span>
                        {o.courier && <span className="text-[#A39E8A]">· {o.courier}</span>}
                        {o.tracking_url && (
                          <a href={o.tracking_url} target="_blank" rel="noreferrer" className="text-[#D4AF37] border-b border-[#D4AF37]/40 pb-0.5 uppercase tracking-[0.2em] text-[10px]" data-testid={`track-${o.id}`}>
                            Urmărește Coletul ↗
                          </a>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="font-serif text-2xl text-[#D4AF37]">{formatPrice(o.amount, o.currency?.toUpperCase() || "RON")}</p>
                    <p className="label-luxe text-[#F3E5AB] mt-2">{o.tracking_status || o.status}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </section>
      </div>
    </main>
  );
}
